import { useTranslation } from '@thoughtspot/i18n';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import { Modal, } from '@thoughtspot/radiant-react/widgets/modal';
import React, { useMemo, useRef, useState } from 'react';
import { TranslationsKeys } from "../../../settings/common";
import { useAdminEditedPageLeaveContext } from "../../../../contexts/context";
import { Actions } from '../actions';
import { ActionButtons } from '../constants';
import { Header } from '../header';
import styles from './content.module.scss';
export var Mode;
(function (Mode) {
    Mode["EDIT"] = "edit";
    Mode["VIEW"] = "view";
})(Mode || (Mode = {}));
export const Content = ({ config, mode = Mode.VIEW, actions, backConfirm = false, pageName, disabled, banner, isFullWidth = false, showHeader = true, onEdit, actionHandler, children = null, }) => {
    const [isEdited, setIsEdited] = useState(false);
    const formBuilderRef = useRef(null);
    const ctx = useAdminEditedPageLeaveContext();
    const { t } = useTranslation();
    const getTranslations = useMemo(() => (key) => t(`${key}`), [0]);
    const actionHandlerCB = (type, returnData = false) => {
        setIsEdited(false);
        ctx.isNotEdited();
        if (actionHandler) {
            if (returnData) {
                const currentFormData = type === ActionButtons.SAVE
                    ? formBuilderRef.current.validateAndSubmitForm()
                    : formBuilderRef.current.onSubmitForm();
                actionHandler(type, currentFormData);
            }
            else {
                actionHandler(type);
            }
        }
    };
    const actionsProps = useMemo(() => {
        const actionsWithHandler = {};
        if (actions) {
            Object.keys(actions).forEach((actionKey) => {
                const action = actions[actionKey];
                const { text, type, returnData = false } = action;
                const askConfirm = 'askConfirm' in action ? action.askConfirm : undefined;
                actionsWithHandler[actionKey] = {
                    text,
                    askConfirm,
                    onClick: () => {
                        actionHandlerCB(type, returnData);
                    },
                };
            });
        }
        return actionsWithHandler;
    }, [actions]);
    const handleIsEdited = (edited, id) => {
        if (edited) {
            ctx.isEdited(edited);
        }
        else {
            ctx.isNotEdited();
        }
        setIsEdited(edited);
        const currentFormData = formBuilderRef.current.onSubmitForm();
        if (onEdit) {
            onEdit(currentFormData, id);
        }
    };
    const getChildrenProps = () => {
        const childrenDefaultProps = {
            ...children.props,
            onAction: () => children.props?.onAction(formBuilderRef),
        };
        return childrenDefaultProps;
    };
    const leaveModalProp = {
        title: getTranslations(TranslationsKeys.MODAL_TITLE),
        isOpen: ctx.sideTabClicked,
        dismissButton: {
            text: getTranslations(TranslationsKeys.MODAL_CANCEL_BTN),
        },
        onDismiss: () => {
            ctx.onSaveClick();
        },
        confirmButton: {
            text: getTranslations(TranslationsKeys.MODAL_CONFIRM_BTN),
            onConfirm: () => {
                Object.keys(actions).forEach((action) => {
                    const { returnData = false } = actions[action];
                    actionHandlerCB(ActionButtons.CANCEL, returnData);
                });
                ctx.onSaveClick();
            },
        },
        body: getTranslations(TranslationsKeys.MODAL_CONTENT),
    };
    const createModal = (body, { title: ModalTitle, isOpen, dismissButton, onDismiss, confirmButton, }) => (React.createElement(Modal, { title: ModalTitle, isOpen: isOpen, dismissButton: dismissButton, onDismiss: onDismiss, size: 'small', confirmButton: confirmButton },
        React.createElement("div", null, body)));
    return (React.createElement(React.Fragment, null,
        ctx.edit && createModal(leaveModalProp.body, leaveModalProp),
        showHeader && (React.createElement(Header, { actions: mode === Mode.VIEW && config.actions
                ? config.actions
                : undefined, title: config.title, subTitle: config.subTitle, askBackConfirm: backConfirm, isFormModified: isEdited, titleSize: mode === Mode.VIEW ? 'medium' : 'large', mode: mode, pageName: pageName, learnMoreKey: config.learnMoreKey, banner: banner, isFullWidth: isFullWidth, actionHandler: actionHandlerCB, buttonType: config.buttonType || 'secondary' })),
        config.formFields.length > 0 && (React.createElement("div", { className: styles.contentWrapper },
            React.createElement(FormBuilder, { ref: formBuilderRef, itemLayout: "horizontal", formFields: config.formFields, viewMode: mode, isEdited: handleIsEdited }))),
        mode === Mode.EDIT &&
            children !== null &&
            React.cloneElement(children, getChildrenProps()),
        mode === Mode.EDIT && (React.createElement(Actions, { ...actionsProps, pageName: pageName }))));
};
//# sourceMappingURL=content.container.js.map